import { ArgumentError } from '../utils/errors';
import { BaseAPIModel } from '@weezevent/weezjs-core';

export default class CashBalance extends BaseAPIModel {
    static list(item) {
        return item;
    }

    static listUrl({ organizationId, ticket_officeId }) {
        if (!ticket_officeId || !organizationId) {
            throw new ArgumentError(`[Model] organizationId and ticket_officeId are mandatory`);
        }

        return `/ticket/organizations/${organizationId}/ticket_office/${ticket_officeId}/cash_balance`;
    }
}
